import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { AuthService } from 'src/app/auth.service';
import { HttpService } from '../../services/http.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewInit {
  showHeader = true;
  noProject: any
  selectedMenu=""
  public userData:any;
  selectUser = false;

  constructor(public router:Router, public appService:AppService, private authService:AuthService, private httpService:HttpService) {
    this.appService.headerLoadingEmitter.subscribe((evt:any)=>{
      let data:any = sessionStorage.getItem('user-data')    
      this.userData = JSON.parse(data)
      this.ngOnInit();
    });
    let data:any = sessionStorage.getItem('user-data')    
    this.userData = JSON.parse(data)
    this.appService.selectedTheme = this.userData?.Email.includes('dhl') ? true : false   ;
    this.httpService.watchStorage().subscribe((data:any) => {
      sessionStorage.clear();
      this.router.navigateByUrl('/login');
    }); 
  }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.selectUser = false;
        if((event.url).includes('page-not-found')){
          return;
        }
         if(event.url === "/auth" || event.url === '/login'){
          this.showHeader = false
          return;
        }
        else{          
          this.showHeader = true;
          this.userData = this.appService.userData;
          this.appService.selectedTheme = this.userData?.Email.includes('dhl') ? true : false
          this.showHeader = true;
        }
        // if(this.appService.isLoggedIn){
        //   this.router.navigateByUrl('page-not-found')
        //   return;
        // }
        this.onCheckWithRouterURL(event.url)
        this.ngAfterViewInit();
      }
    });
    if((this.router.url).includes('page-not-found')){
      return;
    }
    this.onCheckWithRouterURL(this.router.url)
  }

  ngAfterViewInit(): void {
    if(this.router.url.includes("/auth") || this.router.url.includes('/login')){
      this.showHeader = false
      return;
    }
    this.showHeader = true;
    if(this.appService.userData?.LastName){
      this.userData = this.appService.userData;
      this.appService.selectedTheme = this.userData?.Email.includes('dhl') ? true : false
      this.showHeader = true;
    }
    // setTimeout(() => {
      let data:any = sessionStorage.getItem('user-data')    
      this.userData = JSON.parse(data)
      this.appService.selectedTheme = this.userData.Email.includes('dhl') ? true : false
      this.showHeader = true;
      this.appService.userData 
    // }, 5000);
  }

  onMenuSelection(menu: string) {
    this.selectedMenu = menu;
    this.router.navigateByUrl('/home/'+menu)
  }

  onProfileDropDown(){
    this.selectUser = !this.selectUser
  }
  onCheckWithRouterURL(menu:string){  
    if(this.router.url.includes("/auth") || this.router.url.includes('/login')){
      this.showHeader = false
      return;
    } 
    // this.appService.selectedTheme = this.userData.Email.includes('dhl') ? true : false 
    this.showHeader = true;
    if(this.appService.userData?.LastName){
      this.userData = this.appService.userData;
    }
    if(menu === '/home/rate-agreement' || menu === '/home/rate-agreement/edit-agreement'){
      this.selectedMenu = "rate-agreement"
    }
    else if(menu === '/home/contact' || menu === '/home/contact/edit-contact'){
      this.selectedMenu = "contact"
    }
    else if(menu === '/home/bidpack' || menu === '/home/bidpack/edit-bidpack'){
      this.selectedMenu = "bidpack"
    }
    else if(menu === '/home/carrier' || menu === '/home/carrier/edit-carrier'){
      this.selectedMenu = "carrier"
    }
    else if(menu === '/home/fuel-escalator' || menu === '/home/fuel-escalator/edit-fuel-escalator'){
      this.selectedMenu = "fuel-escalator"
    }
    else if(menu === '/home'){
      this.selectedMenu =""
      this.router.navigateByUrl('/home');
    }
    else if(menu.includes('page-not-found')){
      this.router.navigateByUrl('/page-not-found');
    }
    else{
    //  this.showHeader =false;
    }
  }

  onHelpIcon(){}
  onMaintenace(){}

  styleReturnWithTheme(str:string): any {
    if(str === 'sub')
      return this.appService.selectedTheme ? { 'background': 'linear-gradient(90deg, #FFCC00 -0.13%, #FFCC00 29.87%, #FFDE59 72.87%, #FFF0B2 99.87%)' } : { 'background': '#2A6BAC' };
    else if(str === 'header')
      return this.appService.selectedTheme ? { 'background': 'linear-gradient(90deg, #FFCC00 -0.13%, #FFCC00 29.87%, #FFDE59 72.87%, #FFF0B2 99.87%)' } : { 'background': '#fff' };

  }

  onLogout(){
    this.authService.logout();
    this.router.navigateByUrl('/login');
  }
}
